import { render } from "./ShowDetail.vue?vue&type=template&id=6688b1a2&scoped=true"
import script from "./ShowDetail.vue?vue&type=script&lang=js"
export * from "./ShowDetail.vue?vue&type=script&lang=js"

import "./ShowDetail.vue?vue&type=style&index=0&id=6688b1a2&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6688b1a2"]])

export default __exports__